import React, { useEffect, useRef } from "react";
import { notEmpty } from "@fidget/common/utils/not-empty";

type Props = {
  onClickAway: () => void;
  insideTargetDivs?: Array<React.MutableRefObject<HTMLElement | undefined>>;
} & React.PropsWithChildren<{}> &
  React.HTMLAttributes<HTMLDivElement>;

export const ClickAwayListener = ({ onClickAway, insideTargetDivs, children, ...rest }: Props) => {
  const div = useRef<HTMLDivElement | undefined>();

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside, false);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event: Event) => {
    const wasClickedInPassedDivs =
      insideTargetDivs &&
      !insideTargetDivs
        .map((el) => el.current)
        .filter(notEmpty)
        .find((el) => !el.contains(event.target as Node));

    if (!wasClickedInPassedDivs && div.current && !div.current.contains(event.target as Node)) {
      onClickAway();
    }
  };

  return (
    <div ref={(el) => (div.current = el || undefined)} {...rest}>
      {children}
    </div>
  );
};
